<template>
  <div class="language-toggle">
    <div
      class="language-toggle__block"
      v-for="lang in languages"
      :key="lang.locale"
      @click="changeLocale(lang.locale)"
    >{{lang.text}}</div>
  </div>
</template>
<script>
const LANGUAGES = [
  {
    text: "EN",
    locale: "en"
  },
  {
    text: "FR",
    locale: "fr"
  },
  {
    text: "简体",
    locale: "zhcn"
  },
  {
    text: "繁體",
    locale: "zhtw"
  }
];
export default {
  name: "LanguageToggle",
  data() {
    return {
      languages: LANGUAGES
    };
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale;
    }
  }
};
</script>
<style lang="css">
.language-toggle {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
  width: 50px;
  height: 50px;
}

.language-toggle__block {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  background-color: rgba(133, 133, 133, 0.897);
  color: white;
  cursor: pointer;
  transition: 0.3s;
}

.language-toggle__block:hover {
  color: rgba(133, 133, 133, 0.897);
  background-color: white;
}

@media only screen and (max-width: 870px) {
  .language-toggle {
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>